var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKeyGreen = function SvgKeyGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2594 1.74151C13.1665 -0.351317 9.76143 -0.351284 7.6686 1.74154C6.23909 3.17105 5.74255 5.2777 6.36153 7.18898L0.316796 13.2337C0.22529 13.3252 0.173828 13.4491 0.173828 13.5787V16.3391C0.173828 16.6088 0.39207 16.8271 0.661774 16.8271H3.42218C3.55178 16.8271 3.67568 16.7756 3.76716 16.6841L4.45714 15.9936C4.56244 15.8883 4.6139 15.7406 4.59676 15.5924L4.51098 14.851L5.53833 14.7542C5.77183 14.7323 5.95624 14.5479 5.97817 14.3144L6.07491 13.287L6.81636 13.3733C6.95406 13.3919 7.09273 13.3456 7.19709 13.2532C7.30095 13.1603 7.36052 13.0278 7.36052 12.8887V11.9802H8.25254C8.38214 11.9802 8.50605 11.9287 8.59752 11.8372L9.84884 10.6024C11.7596 11.2219 13.8299 10.7628 15.2594 9.33229C17.3522 7.2395 17.3522 3.83433 15.2594 1.74151ZM13.879 5.19192C13.3081 5.76278 12.3799 5.76278 11.809 5.19192C11.2382 4.62106 11.2382 3.69283 11.809 3.12197C12.3799 2.5511 13.3081 2.5511 13.879 3.12197C14.4498 3.69283 14.4498 4.62106 13.879 5.19192Z",
    fill: "#4CD964"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKeyGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key_green.353a70ef.svg";
export { ForwardRef as ReactComponent };